module.exports = __webpack_public_path__ + "static/logo-b51a920a28a45a61955b58198455f1cc.png";